import { render, staticRenderFns } from "./GlActivityChip.vue?vue&type=template&id=4eba73cb&scoped=true"
import script from "./GlActivityChip.vue?vue&type=script&lang=js"
export * from "./GlActivityChip.vue?vue&type=script&lang=js"
import style0 from "./GlActivityChip.vue?vue&type=style&index=0&id=4eba73cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eba73cb",
  null
  
)

export default component.exports